<template>
	<div class="checkout-wrapper">
		<slot />
	</div>
</template>

<style lang="less" scoped>
	.checkout-wrapper{
		width: 700px; margin: auto; padding: 25px 0;
		@media (max-width: @m){width: 100%; padding: 30px 15px; font-size: 14px;}
	}
</style>